<app-order-detail
  [getOrder]="getOrder"
  [getAncillaryOrderLines]="getAncillaryOrderLines"
  [changeOrderState]="changeOrderState"
>
</app-order-detail>
